import partsColor from '../json/partsColor.json'

/**
 * Type Array of Record<string, any>
 * @typedef { Record<string, any>[] } RecordList
 */

/**
 * Get slat & parts list by product type
 *
 * @param {string} prefix - product type prefix (JSON file name)
 * @param {string} type - product type name
 * @returns {[RecordList, RecordList]} - [slatList, partsList]
 */
export const getSlatAndPartsListByType = async (prefix, type) => {
  const slatList = await import(`../json/items/${prefix}.json`)
      .then(({default: m}) => {
          return m.filter(entry => entry.types.includes(type))
      })
  const typeList = await import('../json/productType.json')
          .then(({default: m}) => ( m.find(({prefix: target}) => target === prefix).types ));
  const partsList = typeList.find(({type: target}) => target === type).parts
          .flatMap(key => {
              return typeof key === 'object'
                  ? partsColor.filter(({type}) => type === key.type)
                  : partsColor.find(({id}) => id === key)
          });
  // console.log(partsList)
  return [slatList, partsList]
}

/**
 * Get items prop 'name' suffix for secondary target start with "_"
 *
 * @param {string} productType - product type name
 * @param {string} type - feature type name
 * @returns {string} - suffix starts with "_"
 */
export const getUpdateSuffix = (productType, type) => {
  let sfx = '';
  if (productType === 'LD-PE-100') { sfx = '_lace'; }
  else if (productType === 'HS-PAIR') { sfx = '_bottom'; }
  else if (type === 'frontBack') { sfx = '_back'; }
  else if (type === 'topBottom') { sfx = '_bottom'; }
  // else { sfx = '_unknown'; }
  return sfx;
}